/**
 * @file _view/_cta-button.js
 */
(function ($) {
	'use strict';

	/**
	 * @namespace CtaButton
	 * @constructor
	 * @classdesc CAT Button
	 * @param {object} $e -対象となる jQuery オブジェクト
	 */

	var CtaButton = function ($e) {
		this._$e = $e;
		this._$e.on('click', this.getDataValue.bind(this));
	};


	/**
	 * @memberOf CtaButton
	 * @const
	 */
	CtaButton._classname = 'CtaButton';


	/**
	 * CTA Button のdata属性を取得する
	 * @type CtaButton
	 */
	CtaButton.prototype.getDataValue = function () {
		var dataValue = this._$e.data('cta');
		this.sendData(dataValue);
	};


	/**
	 * CTA Button のdata属性をanalyticsに送信する
	 * @type {CtaButton}
	 */
	CtaButton.prototype.sendData = function (dataValue) {
		ga('send', 'event', 'pushCtaButton', 'click', dataValue);
	};


	module.exports = CtaButton;
})(jQuery);
